var GenericView = require('views/generic.view.ts');
var _ = require("underscore");
var Handlebars = require('handlebars');
var Template = require('text-loader!../templates/general.template.html');
var MapView = require("views/map.view.ts");

var TheView = GenericView.extend({
    el: '#general',
    tagName: '',
	template: Handlebars.compile(Template),
	fields: [],
	initialize: function (options) {
        this.render();
        GenericView.prototype.storeView(this, "general");
    },
    superRender: GenericView.prototype.render,
    render: function () {
        this.superRender();
        this.$el.html(this.template);
        this.showMap();
    },
    events: {
        "input .to-validation input": "validateIt"
    },
    showMap: function(e)
    {
        if(this.mapView == null)
            this.mapView = new MapView();

        this.mapView.renderMap();
    },
    validateIt: _.debounce(
        function(event)
        {
            var element = $(event.currentTarget);
            this.validateSingleField(element);
        },
    300),
    getAllData: function() {
        var data = {
            number_of_residents: this.convertToInt("#number_of_residents"),
            number_of_residents_under_ten: this.convertToInt("#number_of_residents_under_ten"),
            number_of_men: this.convertToInt("#number_of_men"),
            number_of_women: this.convertToInt("#number_of_women"),
            fi: this.convertToFloat("#fi"),
            fo: this.convertToFloat("#fo"),
            north_facade: this.convertToFloat("input[name=north-facade]"),
            east_facade: this.convertToFloat("input[name=east-facade]"),
            building_height: this.convertToFloat("input[name=building-height]"),
            basement_depth: this.convertToFloat("input[name=basement-depth]"),
            number_of_floors: this.convertToInt("input[name=floors]"),
            zone_of_the_building: $("input[name=zone_of_building]:checked").val(),
            typeOfSoil: $("input[name=type_of_soil]:checked").val()
        };

        return data;
    }
});

module.exports= TheView;